import React, { useEffect } from 'react';
import { AlertSnackbar } from '../AlertSnackbar/AlertSnackbar.component';
import Loader from '../Loader/Loader.component';
import { useLayoutContext } from '../../Context/Layout.context';
import { AlertType } from '../../const/alerts';
import { usePromptContext } from '../../Context/Prompt.context';

const getAlertDefaultMessage = (alertType: AlertType): string => {
  switch (alertType) {
    case 'success':
    case 'save_success':
      return 'Dane zostały pomyślnie zapisane.';
    case 'delete_success':
      return 'Dane zostały pomyślnie usunięte.';
    case 'error':
      return 'Zapisanie danych nie powiodło się. Spróbuj ponownie później.';
    case 'get_error':
      return 'Pobranie danych nie powiodło się. Spróbuj ponownie później.';
    case 'save_error':
      return 'Zapisanie danych nie powiodło się. Spróbuj ponownie później.';
    case 'send_error':
      return 'Wysłanie danych nie powiodło się. Spróbuj ponownie później.';
    case 'delete_error':
      return 'Usunięcie danych nie powiodło się. Spróbuj ponownie później.';
    default:
      return 'Operacja nie powiodła się. Spróbuj ponownie później.';
  }
};

export const LoaderAlert: React.FC<{ hideLoader?: boolean; hideAlerts?: boolean }> = ({ hideLoader, hideAlerts }) => {
  const { isLoader, alertOpen, alertType, loaderText, alertMessage, setAlert } = useLayoutContext();
  const { forceClosingAlert, setForceClosingAlert } = usePromptContext();

  const alertText = alertMessage ?? getAlertDefaultMessage(alertType);

  useEffect(() => {
    if (alertOpen) {
      setAlert({ alertOpen: false, alertType, message: alertMessage });
    }
  }, [alertOpen, alertType, alertMessage]);

  return (
    <>
      {isLoader && !hideLoader && <Loader text={loaderText ? loaderText : 'Aktualizuję dane'} />}
      {!hideAlerts && (
        <AlertSnackbar
          text={alertText}
          alertType={alertType}
          open={alertOpen}
          forceClosing={forceClosingAlert}
          onForceClosed={() => setForceClosingAlert(false)}
        />
      )}
    </>
  );
};
